import React from "react";
import "./styles/BusinessInfoType02.scss";
import { useTranslation } from "react-i18next";
// import { useLangNavigate } from "../../hooks/useLangNavigate";
const BusinessInfoType02 = () => {
  const { t } = useTranslation();
  // const langNavigate = useLangNavigate();
  // const handleBtn = (e: any) => {
  //   const { to, tap } = contents[Number(e.currentTarget.id)];
  //   if (tap !== -1) {
  //     langNavigate(to, { state: { tap } });
  //   } else window.open("https://www.geosmartspace.com");
  // };
  const contents = [
    {
      to: "/design",
      tap: 0,
      path: "/imgs/bg_home_business_info_solution.png",
      id: "solution",
    },
    {
      to: "digital-transformation",
      tap: 2,
      path: "/imgs/aboutus_history_content_04.png",
      id: "smarthall",
    },
  ];
  return (
    <>
      <div id="business_info_type_02_wrap">
        <div className="title_wrap">
          <h2 className="title">{t("home.business2.title")}</h2>
        </div>
        <div className="content">
          <div className="sub_title">{t("home.business2.sub")}</div>
          <div className="card_wrap">
            {contents.map((content: { path: string; id: string }, index: number) => {
              return (
                <div id={String(index)} className="card" key={`${content.path}_${index}`}>
                  <div className="img_box">
                    <img src={content.path} alt={content.id} />
                  </div>
                  <h3 className="name">{t(`home.business2.content.${content.id}.name`)}</h3>
                  <div className="des">{t(`home.business2.content.${content.id}.des`)}</div>
                  {/* <BtnViewMore id={String(index)} onClick={handleBtn} /> */}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessInfoType02;
